import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

interface ProtectedRouteProps {
  children: JSX.Element;
  allowedRole?: string[];
}

const ProtectedRoute = ({
  children,
  allowedRole = [],
}: ProtectedRouteProps) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user: User | null) => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            const role = userDoc.data().role;
            setUserRole(role);
            setIsAuthenticated(true);
          } else {
            console.warn("User document not found.");
            setIsAuthenticated(false);
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading)
    return <p className="text-center mt-10">Checking authentication...</p>;

  if (!isAuthenticated) return <Navigate to="/" replace />;

  if (allowedRole.length > 0 && !allowedRole.includes(userRole || ""))
    return <Navigate to="/unauthorized" replace />;

  return children;

  // useEffect(() => {
  // 	const unsubscribe = onAuthStateChanged(auth, (user) => {
  // 		setIsAuthenticated(!!user);
  // 		setLoading(false);
  // 	});
  // 	return () => unsubscribe();
  // }, []);

  // if (loading)
  // 	return <p className="text-center mt-10">Checking authentication...</p>;

  // return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
